import React from "react";
import { Container } from "react-bootstrap";
import { Producer } from "./producer";
import { localizeProducer as localize } from "features/localization/localizeService";

export type AddProducerDetailsProps = {
  producer: Producer;
  errors: string[];
};

const AddProducerConfirmation = (props: AddProducerDetailsProps) => (
  <Container>
    <table className="table table-striped">
      <tbody>
        <tr>
          <td>
            <h6>{localize("AddProducerConfirmation_Label_FirstName")}</h6>
          </td>
          <td className="font-weight-bold">{props.producer.firstName}</td>
        </tr>
        <tr>
          <td>
            <h6>{localize("AddProducerConfirmation_Label_LastName")}</h6>
          </td>
          <td className="font-weight-bold">{props.producer.lastName}</td>
        </tr>
        <tr>
        <td>
          <h6>{localize("AddProducerConfirmation_Label_BusinessName")}</h6>
        </td>
        <td className="font-weight-bold">{props.producer.businessName}</td>
      </tr>
      <tr>
        <td>
          <h6>{localize("AddProducerConfirmation_Label_AccountId")}</h6>
        </td>
        <td className="font-weight-bold">
        {props.producer.accountIds.length > 0  ? (
          props.producer.accountIds.join(', ')
        ): ""}</td>
      </tr>
        <tr>
          <td>
            <h6>{localize("AddProducerConfirmation_Label_Email")}</h6>
          </td>
          <td className="font-weight-bold">{props.producer.email}</td>
        </tr>
        <tr>
          <td>
            <h6>{localize("AddProducerConfirmation_Label_Phone")}</h6>
          </td>
          <td className="font-weight-bold">{props.producer.phone}</td>
        </tr>

        <tr>
          <td>
            <h6>{localize("AddProducerConfirmation_Label_Zip")}</h6>
          </td>
          <td className="font-weight-bold">{props.producer.postalCode}</td>
        </tr>
      </tbody>
    </table>
    {props.errors && props.errors.length > 0  && (
      <>
        <h3>{localize("AddProducerConfirmation_Label_Errors")}</h3>
        {props.errors.map((err, i) => <div key={i}>{err}</div>)}
      </>
    )}
  </Container>
);

export default AddProducerConfirmation;
